import {PaymentModeTypeEnum} from './paymentModeType.model';

export default class PaymentMode {
  public code: string;
  public description: string;
  public infoText: string;
  public infoTextSubLine: string;
  public visible = true;
  public dataAutomationId: string;

  constructor(paymentMode: PaymentMode) {
    this.code = paymentMode.code;
    this.description = paymentMode.description;
    this.infoText = paymentMode.infoText;
    this.infoTextSubLine = paymentMode.infoTextSubLine;
    this.dataAutomationId = this.getDataAutomationId() + '-payment-radiobutton';
  }

  public setChangedVisibility(flag: boolean): void {
    this.visible = flag;
  }

  private getDataAutomationId(): string {
    switch (this.code) {
      case PaymentModeTypeEnum.COURIER_COD:
        return 'cash-on-delivery';

      case PaymentModeTypeEnum.COURIER_COD_CARD:
        return 'card-on-delivery';

      case PaymentModeTypeEnum.COURIER_COD_CREDIT:
        return 'installment';

      case PaymentModeTypeEnum.COURIER_ONLINE:
        return 'online';

      default:
        return '';
    }
  }
}
